import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  root: {
    height: "72px",
    padding: "24px 0",
  },
  button: {
    display: "inline-flex",
    marginRight: "8px",
  },
  footerItem: {
    display: "flex",
  },
  footerBrandRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "12px",
  },
  footerLogo: {
    flexShrink: 0,
  },

  textField: {
    visibility: "hidden",
    "&::after": {
      display: "none !important",
    },
    "&::before": {
      display: "none !important",
    },
    "& .MuiNativeSelect-select:focus": {
      backgroundColor: theme.palette.background.main,
    },
    "& .MuiSelect-select": {
      fontSize: "14px",
      padding: "0px 22px 3px 0px",
      color: theme.palette.secondary.tint60,
    },
    "& .MuiSvgIcon-root": {
      color: theme.palette.secondary.tint60,
    },
  },
  footerImg: {
    display: "inline-block",
    verticalAlign: "bottom",
  },
  icon: {
    width: "24px",
    height: "24px",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.secondary.tint40
        : "rgba(157, 161, 178, 0.25)",
    borderRadius: "50%",
    justifyContent: "center",
    alignContent: "center",
    display: "flex",
    "& img": {
      width: "24px",
      height: "24px",
    },
    "&:hover": {
      backgroundColor: theme.palette.secondary.tint90,
    },
  },
  dropdownStyle: {
    opacity: "1",
    width: "124px",
    height: "126px",
    backgroundColor:
      theme.palette.type === "dark"
        ? theme.palette.secondary.tint90
        : theme.palette.secondary.tint60,
    borderRadius: "8px",
    padding: "6px",
    boxShadow: theme.palette.shadow4,
    "& .MuiList-padding": {
      padding: "0px",
    },
  },
  menuList: {
    cursor: "pointer",
    color: theme.palette.white.qrCode,
    "& .MuiMenuItem-root": {
      fontSize: "14px",
      "&:hover": {
        color: theme.palette.white.qrCode,
        backgroundColor: theme.palette.teal.tint40,
      },
    },
    "& .Mui-selected": {
      backgroundColor: theme.palette.secondary.tint90,
      borderRight: "none !important",
      "&:hover": {
        backgroundColor: "inherit !important",
      },
      "&:after": {
        content: "close-quote",
        display: "block",
        height: "20px",
        width: "20px",
        position: "absolute",
        top: "5px",
        right: "0px",
        backgroundImage: "url(/static/icons/Icon-Svg/check-green.svg)",
      },
    },
  },
  pageContentWrapper: {
    margin: 0,
    padding: [theme.spacing(0, 26), "!important"],
    "&.classOpanMenu": {
      padding: [theme.spacing(0, 26, 0, 12), "!important"],
    },
    [theme.breakpoints.up("xl")]: {
      padding: [theme.spacing(0, 100), "!important"],
      "&.classOpanMenu": {
        padding: [theme.spacing(0, 100), "!important"],
      },
    },
    "&.paddingLayout": {
      padding: [theme.spacing(6, 26), "!important"],
      "&.opanMenu": {
        padding: [theme.spacing(6, 26, 6, 12), "!important"],
      },
    },
  },
}));
